import React from 'react';
import {useEnvironment, useTranslation} from '@wix/yoshi-flow-editor';
import {useControllerProps} from '../../../domain/controllers/ControllerContext';
import s from './CouponTotal.scss';
import classnames from 'clsx';
import {shorten} from '../../../domain/utils/shorten';
import {TotalUpdateSkeleton} from '../../../components/cart/Widget/Components/OrderSummary/SubTotals/TotalUpdateSkeleton';
import {CouponDiscountScope} from '../../../domain/models/CartSummary/CouponDiscount.model';

export enum CouponTotalDataHook {
  CouponTotalRoot = 'CouponTotal.CouponTotalRoot',
  CouponTotalLabel = 'CouponTotal.CouponTotalLabel',
  CouponTotalCode = 'CouponTotal.CouponCode',
  CouponTotalDiscountValue = 'CouponTotal.CouponDiscountValue',
}

export interface CouponTotalProps {
  shouldShowDivider?: boolean;
}

export const CouponTotal = ({shouldShowDivider = true}: CouponTotalProps) => {
  const {t} = useTranslation();
  const {isRTL} = useEnvironment();
  const {cartModel, cartSummary, changeCartLoaders, isSummaryUpdating, CouponAlignmentInCartAndCheckout} =
    useControllerProps().cartStore;
  const appliedCoupon = cartModel.coupon;
  const couponAmount = cartSummary?.priceSummary?.discount.formattedConvertedAmount;
  const isFreeShippingCoupon = CouponAlignmentInCartAndCheckout
    ? cartSummary?.couponDiscount?.scope === CouponDiscountScope.DELIVERY
    : cartSummary?.couponDiscount?.isFreeShippingCoupon;

  const getCouponRowValueText = (): string | React.ReactNode => {
    if (changeCartLoaders && isSummaryUpdating) {
      return <TotalUpdateSkeleton />;
    }
    if (isFreeShippingCoupon) {
      return t('cart.summary.discount.free_delivery');
    }
    /* istanbul ignore next */
    if (isRTL) {
      return `${couponAmount}-`;
    }
    return `-${couponAmount}`;
  };

  return (
    <div data-hook={CouponTotalDataHook.CouponTotalRoot} className={shouldShowDivider && classnames(s.divider, s.root)}>
      <dl className={changeCartLoaders ? s.couponLine : /* istanbul ignore next */ undefined}>
        <dt>
          <span data-hook={CouponTotalDataHook.CouponTotalLabel}>{t('cart.coupon')}</span>{' '}
          <span data-hook={CouponTotalDataHook.CouponTotalCode}>
            {shorten(appliedCoupon.code.toUpperCase(), 10, '...')}
          </span>
        </dt>
        <dd
          data-hook={CouponTotalDataHook.CouponTotalDiscountValue}
          data-wix-coupon-discount-value={CouponTotalDataHook.CouponTotalDiscountValue}>
          {getCouponRowValueText()}
        </dd>
      </dl>
    </div>
  );
};
